import { Box, Button, DialogContent, Typography } from '@mui/material';
import SuccessIcon from 'app/components/Icons/SuccessIcon';
import CustomDialog from 'app/components/ui/Dialog/Dialog';
import { useCustomNavigate } from 'app/utils/customHooks/useCustomNavigate';
import { useTranslation } from 'react-i18next';

interface SuccessDialogProps {
  open: boolean;
  edit?: boolean;
  handleClose: () => void;
  label: string;
}

const TemplatesSuccessDialog = ({ open, edit, handleClose, label }: SuccessDialogProps) => {
  const { t } = useTranslation();
  const navigate = useCustomNavigate();

  return (
    <CustomDialog maxWidth='sm' closeIcon={false} open={open} handleClose={handleClose}>
      <DialogContent
        sx={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          padding: '40px !important',
          gap: '16px',
        }}
      >
        <SuccessIcon />
        <Typography sx={{ fontSize: '24px', fontWeight: 600, textAlign: 'center' }}>
          {label}
        </Typography>
        <Box display='flex' gap={2}>
          <Button onClick={() => navigate('templates-page')}>
            {t('commonActions.goToTemplates')}
          </Button>
          <Button color='secondary' onClick={handleClose}>
            {t('commonActions.close')}
          </Button>
        </Box>
      </DialogContent>
    </CustomDialog>
  );
};

export default TemplatesSuccessDialog;
